import { useEffect, useState } from "react";
import {
  StakingAnylyticsInfo,
  StakingPoolItemModel,
} from "src/models/StakingPool";
import adaIcon from "src/assets/images/icon_ada.svg";
import atomIcon from "src/assets/images/icon_atom.svg";
import eosIcon from "src/assets/images/icon_eos.svg";
import ethIcon from "src/assets/images/icon_eth.svg";
import irisIcon from "src/assets/images/icon_iris.svg";
import xtzIcon from "src/assets/images/icon_xtz.svg";
import iotxIcon from "src/assets/images/icon_iotx.svg";
import linkIcon from "src/assets/images/icon_link.svg";
import solIcon from "src/assets/images/icon_sol.svg";
import maticIcon from "src/assets/images/icon_matic.png";
import wanIcon from "src/assets/images/icon_wan.svg";
import roseIcon from "src/assets/images/icon_rose.svg";
import kavaIcon from "src/assets/images/icon_kava.svg";
import aktIcon from "src/assets/images/icon_akt.svg";
import atpIcon from "src/assets/images/icon_atp.svg";
import mtrgIcon from "src/assets/images/icon_mtrg.svg";
import rowanIcon from "src/assets/images/icon_rowan.svg";
import pdexIcon from "src/assets/images/icon_pdex.svg";
import minaIcon from "src/assets/images/icon_mina.svg";
import fraIcon from "src/assets/images/icon_fra.svg";
import edgIcon from "src/assets/images/icon_edg.svg";
import pcxIcon from "src/assets/images/icon_pcx.svg";
import iostIcon from "src/assets/images/icon_iost.svg";
import nmtIcon from "src/assets/images/icon_nmt.svg";
import NYMIcon from "src/assets/images/icon_nym.svg";
import JUNOIcon from "src/assets/images/icon_juno.svg";
import FLIXIcon from "src/assets/images/icon_omniflix.png";
import UMEEIcon from "src/assets/images/icon_umee.svg";
import EVMOSIcon from "src/assets/images/icon_evmos.svg";
import GRAVITONIcon from "src/assets/images/icon_gravity.png";
import MyriadIcon from "src/assets/images/icon_myriad.png";
import ConfluxIcon from "src/assets/images/icon_conflux.svg";
import DeBioIcon from "src/assets/images/icon_deBio.png";
import MetisIcon from "src/assets/images/icon_Metis.svg"
// import MyriadIcon from "src/assets/images/icon_myriad.png";

export function useStakingInfo() {
  const [items, setItems] = useState<StakingPoolItemModel[]>([]);
  const [info, setInfo] = useState<StakingAnylyticsInfo>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchPools();
  }, []);

  const fetchPools = async () => {
    setLoading(true)
    const response = await fetch(
      "https://api.wetez.io/blossom/v1/officialapi/wallet/poollist"
    );
    const resJson = await response.json();
    if (resJson.status === "80000" && resJson.data?.list) {
      resJson.data.list.forEach((element: StakingPoolItemModel) => {
        if (element.symbol === "XTZ") {
          element.icon = xtzIcon;
        } else if (element.symbol === "ATOM") {
          element.icon = atomIcon;
        } else if (element.symbol === "ADA") {
          element.icon = adaIcon;
        } else if (element.symbol === "EOS") {
          element.icon = eosIcon;
        } else if (element.symbol === "IRIS") {
          element.icon = irisIcon;
        } else if (element.symbol === "ETH") {
          element.icon = ethIcon;
        } else if (element.symbol === "IOTX") {
          element.icon = iotxIcon;
        } else if (element.symbol === "LINK") {
          element.icon = linkIcon;
        } else if (element.symbol === "SOL") {
          element.icon = solIcon;
        } else if (element.symbol === "MATIC") {
          element.icon = maticIcon;
        } else if (element.symbol === "WAN") {
          element.icon = wanIcon;
        } else if (element.symbol === "ROSE") {
          element.icon = roseIcon;
        } else if (element.symbol === "KAVA") {
          element.icon = kavaIcon;
        } else if (element.symbol === "AKT") {
          element.icon = aktIcon;
        } else if (element.symbol === "ATP") {
          element.icon = atpIcon;
        } else if (element.symbol === "MTRG") {
          element.icon = mtrgIcon;
        } else if (element.symbol === "ROWAN") {
          element.icon = rowanIcon;
        } else if (element.symbol === "PDEX") {
          element.icon = pdexIcon;
        } else if (element.symbol === "MINA") {
          element.icon = minaIcon;
        } else if (element.symbol === "FRA") {
          element.icon = fraIcon;
        } else if (element.symbol === "EDG") {
          element.icon = edgIcon;
        } else if (element.symbol === "PCX") {
          element.icon = pcxIcon;
        } else if (element.symbol === "IOST") {
          element.icon = iostIcon;
        } else if (element.symbol === "NMT") {
          element.icon = nmtIcon;
        } else if (element.symbol === "JUNO") {
          element.icon = JUNOIcon;
        } else if (element.symbol === "FLIX") {
          element.icon = FLIXIcon;
        } else if (element.symbol === "UMEE") {
          element.icon = UMEEIcon;
        } else if (element.symbol === "EVMOS") {
          element.icon = EVMOSIcon;
        } else if (element.symbol === "GRAVITON") {
          element.icon = GRAVITONIcon;
        } else if (element.symbol === "NYM") {
          element.icon = NYMIcon;
        } else if (element.symbol === "MYRIA") {
          element.icon = MyriadIcon
        } else if (element.symbol === "CFX") {
          element.icon = ConfluxIcon
        } else if (element.symbol === "DBIO") {
          element.icon = DeBioIcon
        } else if (element.symbol === "METIS"){
          element.icon = MetisIcon
        }

        if (element.validatorAddress.length <= 42) {
          element.omitAddress = element.validatorAddress;
        } else {
          element.omitAddress = `${element.validatorAddress.substr(
            0,
            19
          )}...${element.validatorAddress.substr(
            element.validatorAddress.length - 18,
            18
          )}`;
        }

        if (element.apy.length === 0 || isNaN(Number(element.apy))) {
          element.displayApy = "--";
        } else {
          element.displayApy = element.apy;
        }

        if (
          element.nodeName === "Tezos" ||
          element.nodeName === "Cosmos" ||
          element.nodeName === "IRISnet" ||
          element.nodeName === "IoTex" ||
          element.nodeName === "Ethereum" ||
          element.nodeName === "Polygon" ||
          element.nodeName === "Solana" ||
          element.nodeName === "Wanchain" ||
          element.nodeName === "Oasis" ||
          element.nodeName === "Kava" ||
          element.nodeName === "Akash" ||
          element.nodeName === "Alaya" ||
          element.nodeName === "Meter" ||
          element.nodeName === "Sifchain" ||
          element.nodeName === "Polkadex" ||
          element.nodeName === "Mina" ||
          element.nodeName === "Findora" ||
          element.nodeName === "Edgeware" ||
          element.nodeName === "ChainX" ||
          element.nodeName === "IOST" ||
          element.nodeName === "NFTMart" ||
          element.nodeName === "Nym" ||
          element.nodeName === "Juno" ||
          element.nodeName === "OmniFlix" ||
          element.nodeName === "Evmos" ||
          element.nodeName === "Umee" ||
          element.nodeName === "Gravity-Bridge" ||
          element.nodeName === "Umee" ||
          // element.nodeName === "Conflux" ||
          element.nodeName === "Myriad" || 
          element.nodeName === "DebioNetwork"
        ) {
          element.opened = true;
        } else {
          element.opened = false;
        }
      });
      setItems(resJson.data.list.filter((item: StakingPoolItemModel) => {
        return true //!!item.icon
      }));
      setLoading(false)
    }

    if (resJson.status === "80000" && resJson.data?.info) {
      setInfo(resJson.data.info);
    }
  };

  return { items, info, loading };
}
